import { GTM_EVENT } from 'components/SeoSuite/helpers/dataLayer';
import {
    CartAlteredAction,
    IGtmList,
    IGtmProduct,
    ICartAlteredDetail,
    ISearchDetail,
    IViewItemListDetail,
} from 'components/SeoSuite/interfaces/IGtmEventDetail';

const dispatch = <T>(type: string, detail: T) => {
    window.dispatchEvent(
        new CustomEvent<T>(type, { detail }),
    );
};

export const dispatchViewItemList = (list: IGtmList, items: IGtmProduct[]): void => {
    dispatch<IViewItemListDetail>(GTM_EVENT.viewItemList, { list, items });
};

/**
 * Doubles as the signal the cart blocks listen to, so it is dispatched on every cart change.
 */
export const dispatchCartAltered = (action?: CartAlteredAction, items: IGtmProduct[] = []): void => {
    dispatch<Partial<ICartAlteredDetail>>(GTM_EVENT.cartAltered, { action, items });
};

export const dispatchSearch = (term: string, type: string, resultsCount: number): void => {
    dispatch<ISearchDetail>(GTM_EVENT.search, { term, type, resultsCount });
};
